import { render, staticRenderFns } from "./resetCode.vue?vue&type=template&id=51c72f7b&"
import script from "./resetCode.vue?vue&type=script&lang=js&"
export * from "./resetCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports